import useFaqData from "../hooks/useFaqData";
import useFaqScroll from "../hooks/useFaqScroll";
import useFaqAccordion from "../hooks/useFaqAccordion";

import FaqTabs from "../components/FaqTabs";
import FaqItem from "../components/FaqItem";
import StillNeedHelp from "../components/StillNeedHelp";
import Footer from "../../../../components/Footer/Footer";
import "../styles/FaqPage.css";
import FaqHero from "../components/FaqHero";

export default function FaqPage() {
  const { faqs, banner, loading, error } = useFaqData();
  const { openFaqs, toggleFaq } = useFaqAccordion(faqs);
  const {
    activeSection,
    sectionRefs,
    scrollToSection,
  } = useFaqScroll(faqs);

  if (loading) return <p>Loading FAQs...</p>;
  if (error) return <p>{error}</p>;
  return (
    <>

      {banner && (
        <FaqHero
          leftMedia={banner.left}
          rightMedia={banner.right}
        />
      )}

      {/* Sections */}
      <div className="faq-sections faq-scroll-page">
        {/* Tabs */}
        <FaqTabs
          faqs={faqs}
          activeSection={activeSection}
          onTabClick={scrollToSection}
        />


        {faqs.map((item) => (
          <div
            key={item.title}
            className="faq-category"
            ref={(el) => (sectionRefs.current[item.title] = el)}
          >
            <h2 className="faq-category-title">{item.title}</h2>

            {item.faqs.map((faq, i) => (
              <FaqItem
                key={faq.id || faq.question}
                faq={faq}
                open={openFaqs[item.title] === i}
                onToggle={() => toggleFaq(item.title, i)}
              />
            ))}
          </div>
        ))}
      </div>
      <StillNeedHelp />
      <Footer />
    </>
  );
}
